<mat-toolbar>
  <span>{{ 'FORM.CHECK_DETAILS' | transloco }}</span>
</mat-toolbar>
<mat-dialog-content class="row">
  <div class="col">
    <mat-list>

      <h3 matSubheader><mat-icon matListIcon style="padding-top:4px">person</mat-icon> {{ 'FORM.NAME' | transloco }}
    </h3>
    <mat-list-item>
      <h4 matLine>{{userInput.customer.customer.firstname}} {{userInput.customer.customer.lastname}}</h4>
    </mat-list-item>

    <mat-divider></mat-divider>

    <h3 matSubheader><mat-icon matListIcon style="padding-top:4px">smartphone</mat-icon> {{ 'FORM.PHONENUMBER' |
  transloco }}</h3>
  <mat-list-item>
    <h4 matLine>{{userInput.customer.customer.cellular}}</h4>
  </mat-list-item>

  <mat-divider></mat-divider>

  <h3 matSubheader><mat-icon matListIcon style="padding-top:4px">email</mat-icon> Email</h3>
  <mat-list-item>
    <h4 matLine>{{userInput.customer.customer.email}}</h4>
  </mat-list-item>

  <mat-divider></mat-divider>

  <h3 matSubheader><mat-icon matListIcon style="padding-top:4px">people</mat-icon> {{ 'FORM.PERSONS' | transloco }}
</h3>
<mat-list-item>
  <h4 matLine>{{userInput.customer.shuttles[0].passengers}}</h4>
</mat-list-item>

<mat-divider></mat-divider>

<h3 matSubheader><mat-icon matListIcon style="padding-top:4px">directions_car</mat-icon> {{ 'FORM.CARID' |
transloco }}</h3>
<mat-list-item>
  <h4 matLine>{{ userInput.customer.parking.carId }}</h4>
</mat-list-item>

<mat-divider></mat-divider>

</mat-list>
</div>
<div class="col">
  <mat-list>

    <h3 matSubheader><mat-icon matListIcon style="padding-top:4px">local_parking</mat-icon> {{ 'FORM.PARKING_FROM' |
  transloco }}</h3>
  <mat-list-item>
    <h4 matLine>{{ userInput.customer.parking.parkingFrom | date : 'yyyy-MM-dd HH:mm'}}
    </h4>
  </mat-list-item>

  <mat-divider></mat-divider>

  <h3 matSubheader><mat-icon matListIcon style="padding-top:4px">local_parking</mat-icon> {{ 'FORM.PARKING_TO' |
transloco }}</h3>
<mat-list-item>
  <h4 matLine>{{ userInput.customer.parking.parkingTo | date : 'yyyy-MM-dd HH:mm'}}
  </h4>
</mat-list-item>

<mat-divider></mat-divider>

@for (shuttle of userInput.customer.shuttles; track shuttle) {
  <div>
    @if (shuttle.productcode=='SHUTDEP') {
      <div>
        <h3 matSubheader><mat-icon matListIcon style="padding-top:4px">flight_takeoff</mat-icon> {{
      'FORM.DEPARTURE_FLIGHT' | transloco }}</h3>
      <mat-list-item>
        <h4 matLine>{{ shuttle.flightnr }} {{ shuttle.flightdate | date : 'yyyy-MM-dd HH:mm' }}</h4>
      </mat-list-item>
      <mat-divider></mat-divider>
    </div>
  }
  @if (shuttle.productcode=='SHUTARR') {
    <div>
      <h3 matSubheader><mat-icon matListIcon style="padding-top:4px">flight_land</mat-icon> {{ 'FORM.ARRIVAL_FLIGHT'
    | transloco }}</h3>
    <mat-list-item>
      <h4 matLine>{{ shuttle.flightnr }} {{ shuttle.flightdate | date : 'yyyy-MM-dd HH:mm' }}</h4>
    </mat-list-item>
    <mat-divider></mat-divider>
  </div>
}
</div>
}

</mat-list>
</div>

</mat-dialog-content>

<mat-toolbar> {{ 'PLACEHOLDER.BOOKING_PRICE' | transloco }}<div class="spacer"></div>
@if (!userInput.cart.totalDiscountPriceIncVat) {
  <span>{{userInput.cart.totalPriceIncVat}}</span>
}
@if (userInput.cart.totalDiscountPriceIncVat) {
  <span>{{userInput.cart.totalDiscountPriceIncVat}} </span>
}
SEK
</mat-toolbar>

<div style="display: flex; justify-content: space-between; align-items: center; margin: 1.2rem;">
  <button mat-raised-button type="button" mat-dialog-close (click)="cancel()" style="width: 25%;" color="warn">
    {{ 'FORM.EDIT' | transloco | uppercase}}
  </button>
  <button cdkFocusInitial mat-raised-button type="button" style="width: 25%;" [disabled]="isLoading"
    (click)="sendConfirmation()" [ngClass]="{'success-button': !isLoading}">
    @if (isLoading) {
      <mat-icon>
        <mat-spinner color="accent" diameter="20">
        </mat-spinner>
      </mat-icon>
      }{{ 'FORM.CONFIRM' | transloco | uppercase}}
    </button>
  </div>